// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 15px;
  margin-right: 10px;
}

ion-item {
  --padding-end: 0px;
  --inner-padding-end: 0px;
  margin: 0 0 10px;
}

ion-item::part(native) {
  padding-inline-start: 0;
}

.close_lbl {
  color: red;
}

h4 {
  color: var(--ion-color-text-color);
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

ion-toggle {
  height: 25px !important;
  --handle-width: 20px;
  --handle-height: 20px;
  --handle-max-height: auto;
}

.class_lbl {
  font-size: 15px;
  color: var(--ion-color-text-color);
  font-family: var(--ion-font-family);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
